module.exports = __webpack_public_path__ + "static/media/table.a2341719.svg";